/** The tour id the letter is recorded under once the founder dismisses it. */
export const FOUNDER_LETTER_ID = 'founder-letter'

export const FOUNDER_NAME = 'Ken Ali'

export const FOUNDER_FIRST_NAME = 'Ken'

/** The address the letter's P.S. points the reader to. */
export const FOUNDER_EMAIL = 'ken.ali@raldo.ai'
